import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';

type DropdownKey = 'company' | 'services' | 'products' | 'resources';

@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
   blogUrl = environment.blogUrl;

  isMenuOpen = false;
  openDropdown: DropdownKey | null = null;

  // UTM parameters
  utmSource: string | null = null;
  utmMedium: string | null = null;
  utmCampaign: string | null = null;
  utmContent: string | null = null;

  constructor(
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
  this.route.queryParams.subscribe(params => {

    this.utmSource = params['utm_source'] ?? null;
    this.utmMedium = params['utm_medium'] ?? null;
    this.utmCampaign = params['utm_campaign'] ?? null;
    this.utmContent = params['utm_content'] ?? null;

    console.log('Header UTM Parameters:', {
      utm_source: this.utmSource,
      utm_medium: this.utmMedium,
      utm_campaign: this.utmCampaign,
      utm_content: this.utmContent
    });

  });
}

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.openDropdown = null;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.openDropdown = null;
  }

  toggleDropdown(key: DropdownKey, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.openDropdown =
      this.openDropdown === key ? null : key;
  }

  isDropdownOpen(key: DropdownKey): boolean {
    return this.openDropdown === key;
  }
}